import React from "react";
import { formatDataNumberToen } from "../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getBidCountShweHour,
  postBidProduct,
} from "../Redux/futures/Bid/action";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getCurrentUser } from "../Redux/futures/account/actions";
import AddItemEvent2024 from "../page/components/EventNewYearAndChristmas_2024/components/AddItem/AddItemEvent2024";
import { setPopupMission } from "../Redux/futures/mini-game/action";
import ModalNewBid from "./ModalNewBid";
import { useNavigate } from "react-router";
import PATH from "../config/PATH";
import {
  KEY_LOCAL_TOUR_COMPLETE,
  KEY_LOCAL_TYPE_USER,
  TYPE_USER,
  urlPageBid,
} from "../helper/const";
import { getData } from "../utils/localstorage";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import { curStateAccount } from "../Redux/selector";
import PopupFrame from "./popups/ui-1";
import iconConfirm from "@assets/web-v3-images/icon-confirm.png";
import iconBidSuccess from "@assets/web-v3-images/icon-success.png";

// Theo design: cả Cancel lẫn Confirm/OK đều là nút cam bo tròn giống nhau.
const BTN =
  "btn-click-active rounded-full bg-linear-to-b from-[#FCAA46] to-[#F27C1A] px-6 py-3 text-[16px] sm:text-[18px] font-extrabold text-white shadow-[0_5px_12px_rgba(230,120,20,0.4)]";

const ModalConfirmBid = ({
  setOpenModal,
  openModal,
  valueInput = 0,
  data = [],
  setValueInput,
  handleMove = () => {},
  setDataTitle,
  dataTitle,
  setIsErrorCode,
  setDataApiBid = () => {},
  setOpenPopupShweHours = () => {},
}) => {
  const [dataApi, setDataApi] = useState(null);
  const selectorAccount = useSelector(curStateAccount);
  const [isLastRemainTurn, setIsLastRemainTurn] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { typeIntroTour } = useSelector((state) => state.reducerHome);
  const title = data[0]?.product_name || "";
  const navigate = useNavigate();

  const afterbid = (data, isLoading, dataError) => {
    if (data) {
      let titlePopup = t("success");
      (+data?.data.errorCode === 7 || +data?.data.errorCode === 5) &&
        (titlePopup = t("Failure"));
      setDataTitle(titlePopup);
      dispatch(getCurrentUser({}));
      setDataApi(data);
      setDataApiBid(data);
      setValueInput("");
      handleMove();
      setIsErrorCode(+data?.data.errorCode);
      dispatch(getBidCountShweHour());
    } else if (dataError) {
      setDataTitle(t("bid_page.sorry"));
      setDataApi(dataError);
    }
  };

  const handleBid = async () => {
    if (selectorAccount.remainTurn.length === 1) {
      setIsLastRemainTurn(true);
    }
    const dataAPi = {
      price: valueInput,
      productCode: data[0]?.product_code,
      callback: afterbid,
    };
    dispatch(postBidProduct(dataAPi));
  };

  const handleOke = () => {
    handleBid();
  };

  const handleOkeApi = () => {
    setOpenModal(false);
    setDataTitle(t("confirmation"));

    // check event sự kiện
    if (dataApi?.data?.reelAddSuper) {
      return dispatch(
        setPopupMission({
          isShow: true,
          type: "super_coin",
          coin: dataApi?.data?.reelAddNormal || 0,
          superCoin: dataApi?.data?.reelAddSuper || 0,
          missionName: dataApi?.data?.missionName,
          dataSelect: dataApi?.data?.missionName,
        }),
      );
    } else if (dataApi?.data?.reelAddNormal) {
      return dispatch(
        setPopupMission({
          isShow: true,
          type: "normar_coin",
          coin: dataApi?.data?.reelAddNormal || 0,
          missionName: dataApi?.data?.missionName,
          dataSelect: dataApi?.data?.missionName,
        }),
      );
    }

    handleNavigateToSubPackage();
  };

  const handleNavigateToSubPackage = () => {
    if (localStorage.getItem(KEY_LOCAL_TYPE_USER) !== null) {
      localStorage.removeItem(KEY_LOCAL_TYPE_USER);
      localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
      dispatch(
        setReduxDataTypeIntroTour({
          typeActive: 0,
          step: -1,
        }),
      );
    }

    if (isLastRemainTurn) {
      navigate(`${PATH.BID}/${urlPageBid.purchasing}`);
    }
  };

  const handleCancel = () => {
    setOpenModal(false);
    setDataTitle(t("confirmation"));
    localStorage.removeItem(KEY_LOCAL_TYPE_USER);
    localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: 0,
        step: -1,
      }),
    );
  };

  // PopupFrame gọi khi đóng (nút thoát / ESC / click nền) -> coi như Cancel.
  const handleOpenChange = (next) => {
    if (!next) handleCancel();
  };

  if (dataApi && +typeIntroTour.step === 4) {
    const dataTypeUser = getData(KEY_LOCAL_TYPE_USER);
    if (
      +dataTypeUser !== TYPE_USER.firstLoginAfterRegistered7Days ||
      +dataTypeUser !== TYPE_USER.general ||
      +dataTypeUser !== TYPE_USER.newPackage ||
      +dataTypeUser !== TYPE_USER.firstLoginWithinRegistered2To6Days
    ) {
      return (
        <ModalNewBid dataApi={dataApi} onClose={handleCancel} open={true} />
      );
    }
  }

  const renderOKText = () => {
    if (dataApi) {
      if (isLastRemainTurn) {
        return t("bid_page.buy_more_turns");
      }
    }
    return "OK";
  };

  // Đặt giá thành công = có kết quả trả về + errorCode 0 (không phải 5/7).
  const isBidSuccess = dataApi?.success && +dataApi?.data?.errorCode === 0;
  // Ảnh cô gái theo trạng thái: xác nhận -> icon-confirm; đặt xong thành công ->
  // icon-bid-success; thất bại thì không hiện ảnh.
  const topIcon = !dataApi ? iconConfirm : isBidSuccess ? iconBidSuccess : null;

  // Nội dung thông báo: kết quả trả về (errorMessage/content) hoặc câu xác nhận.
  const message = dataApi?.errorMessage
    ? dataApi.errorMessage
    : dataApi?.data?.content
      ? dataApi?.data?.content
      : t("bid_page.confirm_bid")
          .replace("_PRICE_", formatDataNumberToen(+valueInput))
          .replace("_NAME_", title);

  return (
    <PopupFrame
      open={openModal}
      onOpenChange={handleOpenChange}
      title={dataTitle}
    >
      {dataApi?.success &&
      dataApi?.data?.sparkAdd &&
      dataApi?.data?.errorCode == 0 ? (
        <AddItemEvent2024 total={dataApi?.data?.sparkAdd} isBid />
      ) : null}

      <div className="pb-2">
        {/* Ảnh cô gái theo trạng thái (xác nhận / đặt thành công) — nền tròn có
            sẵn trong file. Thất bại thì topIcon = null nên không hiện. */}
        {topIcon && (
          <img
            src={topIcon}
            alt=""
            className="mx-auto mb-4 w-[55%] max-w-60 object-contain"
          />
        )}

        <p className="px-2 text-center text-[16px] sm:text-[18px] font-semibold leading-relaxed text-[#A15C07]">
          {message}
        </p>

        {/* dataApi = đã đặt xong -> chỉ 1 nút OK ở giữa; chưa đặt -> Cancel + Confirm */}
        <div className="mt-6 sm:mt-8 flex items-center justify-center gap-4">
          {!dataApi && (
            <button
              type="button"
              onClick={handleCancel}
              className={`${BTN} flex-1 max-w-[45%]`}
            >
              {t("bid_page.cancel")}
            </button>
          )}
          <button
            type="button"
            onClick={dataApi ? handleOkeApi : handleOke}
            className={`${BTN} ${dataApi ? "min-w-[50%]" : "flex-1 max-w-[45%]"}`}
          >
            {dataApi ? renderOKText() : t("bid_page.confirm")}
          </button>
        </div>
      </div>
    </PopupFrame>
  );
};

export default ModalConfirmBid;
